import { parseHandicap } from '../../../../contrib/utils';
import { TOrderType } from './PlayerList';

export const getCustomSorting = (parts: string[], order: TOrderType) => (a: any, b: any) => {
  if (order === 'original' || !a || !b) {
    return 0;
  }

  const aType = parts.reduce((x: any, y: any) => x[y], a);
  const bType = parts.reduce((x: any, y: any) => x[y], b);

  const OrderOne = 1 * (order === 'ascending' ? 1 : -1);
  const OrderMinusOne = -1 * OrderOne;

  if (parts[parts.length - 1] === 'handicapCurrent') {
    const ha = parseHandicap(aType);
    const hb = parseHandicap(bType);

    return ha > hb ? OrderOne : ha < hb ? OrderMinusOne : 0;
  }

  return aType > bType ? OrderOne : aType < bType ? OrderMinusOne : 0;
};
